// ----------------------------------------------------------------------
// <copyright file="Izenda.GlobalAndLocalNames.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Global And Local Names component
 */
!(function () {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var notifyChange = EventsUtils.notifyChange;
  var connect = require('share/enhancers/Izenda.Connect');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var constants = require('logic/data/Izenda.SystemConfigurationConstants');

  var Panel = require('share/components/controls/Izenda.Panel');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ValidateInput = Validator()(require('share/components/controls/Izenda.Input'));

  var GlobalAndLocalNames = function (props) {

    var GlobalAndLocalNamesHeaderPanel = connect()(function (props) {
      var localization = props.localization;

      return (
        <div onClick={props.collapseToggle}>
          <i className="icon-toggle-triangle"></i>
          <strong>{localization.getText('SYSTEM_CONFIGURATION_REPORT_GLOBAL_AND_LOCAL_NAMES')}</strong>
        </div>
      );
    });

    var localization = props.localization;
    var store = props.store;
    var model = store.reportConfiguration;
    var header = {
      className: 'u-bgGray',
      component: GlobalAndLocalNamesHeaderPanel
    }
    return (
      <Panel header={header} collapsible expanedOption panelBodyClassName='izenda-ReportConfiguration-GlobalLocalName_Body'>
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols='2' >
              <label className='u_marginLeft'>
                {localization.getText('SYSTEM_CONFIGURATION_REPORT_GLOBAL_NAME')}
              </label>
            </GridLayout.Col>
            <GridLayout.Col cols='6'>
              <ValidateInput type='text'
                className='form-control'
                maxLength={256}
                value={model.globalCategoryName}
                onChange={notifyChange(model.setValueByKey.bind(model, 'globalCategoryName'), EventsUtils.INPUT)}
                field='globalCategoryName'
                validations={constants.CONSTRAINTS.GLOBAL_NAME} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols='2'>
              <label className='u_marginLeft'>
                {localization.getText('SYSTEM_CONFIGURATION_REPORT_LOCAL_NAME')}
              </label>
            </GridLayout.Col>
            <GridLayout.Col cols='6'>
              <ValidateInput type='text'
                className='form-control'
                maxLength={256}
                value={model.localCategoryName}
                onChange={notifyChange(model.setValueByKey.bind(model, 'localCategoryName'), EventsUtils.INPUT)}
                field='localCategoryName'
                validations={constants.CONSTRAINTS.LOCAL_NAME} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </Panel>
    );
  };

  module.exports = connect()(GlobalAndLocalNames);
}());


// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Report/Izenda.GlobalAndLocalNames.jsx